import { ArtsForms } from './core';
const instance = new ArtsForms();
export default instance.init();
